module.exports={author:"Sadie Dupuis",date:"08/26/2021",publishDate:"08/26/2021",highlighted:!1,tags:"",title:"COME OVER MAKE MAC AND CHEESE :)"};